<template>
  <b-modal size="md" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-input v-model="form.descricao" label="Descricao: *" required></lg-form-input>

            <lg-form-input v-model="form.uf" label="Uf: *" required></lg-form-input>

            <lg-finder-page-pais v-model="form.pais" :value="form.pais" :prefix="updatedPrefix" id="finderPais"
              class='col-12'></lg-finder-page-pais>

            <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
              class="d-flex">
            </b-form-radio-group>

            <div class="d-flex justify-content-center mt-3">
              <b-button id="salvarUnidade" type="submit" variant="success" style="height: 30px" pill size="sm">
                <div class="btn-size-alinhamento">
                  <b-icon icon="check-circle" />
                </div>
                <b-tooltip target="salvarUnidade" title="Salvar" triggers="hover"></b-tooltip>

              </b-button>
              <b-button id="cancelarUnidadeFederativa" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
                <div class="btn-size-alinhamento">
                  <b-icon icon="x-circle" />
                </div>
                <b-tooltip target="cancelarUnidadeFederativa" title="Cancelar" triggers="hover"></b-tooltip>

              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPagePais from "@/components/Finders/LgFinderPagePais.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
    LgFinderPagePais,
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        descricao: "",
        uf: "",
        situacao: 1,
        pais: null,
      },
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/unidade-federativa`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    async submitForm() {
      if (!this.form.pais || !this.form.pais.id) {
        this.$notify({
          type: "danger",
          message: "Seleção de país é obrigatória",
        });
        return;
      }

      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Este registro já está cadastrado'
        });
        return;
      }

    },

    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>
